const concatFilters = (searching) => {
    return `contains(concat(concat(concat(concat(surname,' '), name),' '), patronymic),'${searching}')`;
};
export default concatFilters;
